const prefix = '@responsive';

export const MEDIA_CHANGED = `${prefix}/MEDIA_CHANGED`;
